import React, {useCallback, useEffect, useRef, useState} from "react";
import PrimaryButton from "./PrimaryButton";
import {useDispatch} from "react-redux";
import {FaX} from "react-icons/fa6";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import "./quillSticky.css";
import {editPrice, refreshPris} from "../../reducer/PriceReducer";
import {createPrice} from "../../services/prices";

const PrisEditor = ({setPopup, setEdit, edit}) => {
  const [content, setContent] = useState("");
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (edit.isEdit) {
      setContent(edit.content);
    }
  }, [edit]);
  
  const quillRef = useRef(null); // To store the ReactQuill instance
  const setQuillRef = useCallback((ref) => { // Callback to set the ref and disable spellcheck
    if (ref) {
      quillRef.current = ref;
      // Access the internal Quill editor instance and set spellcheck to false
      const editor = ref.getEditor();
      if (editor && editor.root) {
        editor.root.setAttribute("spellcheck", "false");
      }
    }
  }, []);
  
  const handleChangeData = (value) => {
    setContent(value);
  };
  
  const newObject = {
    item: content,
  };
  
  const handleSaveItem = async (e) => {
    console.log("Saving price item:", newObject);
    e.preventDefault();
    
    try {
      if (edit.isEdit) {
        dispatch(editPrice(edit.id, newObject));
        setEdit({isEdit: false});
        dispatch(refreshPris());
        setPopup(true);
      } else {
        const data = await createPrice(newObject);
        if (data) {
          setContent("");
          setEdit({shown: false});
          setPopup(true);
          dispatch(refreshPris());
        }
      }
    } catch (exception) {
      console.error("saving pris error", exception);
    }
  };
  
  const quillModules = {
    toolbar: [
      [{header: [1, 2, false]}],
      ["bold", "italic", "underline", "blockquote"],
      [{list: "ordered"}, {list: "bullet"}],
      ["link", "image", "video"],
      ["clean"],
    ],
  };
  
  const quillFormats = [
    "header",
    "bold", "italic", "underline", "blockquote",
    "list", "bullet",
    "link", "image", "video"
  ];
  
  return (
    <div className="bg-dark text-black h-full grow max-w-screen-5xl p-4">
      <div className="flex justify-end pb-6">
        <FaX
          className="text-gray text-[22px] cursor-pointer max-sm:text-[18px]"
          onClick={() => {
            setEdit({shown: false});
          }}
        />
      </div>
      <form className="flex flex-col gap-4 pb-2">
        <ReactQuill
          ref={setQuillRef}
          value={content}
          onChange={handleChangeData}
          modules={quillModules}
          formats={quillFormats}
          className="bg-gray text-black rounded w-full min-h-[300px] max-h-[400px] overflow-auto editor-sticky"
          theme="snow"
        />
        <PrimaryButton
          text="Save"
          onClick={handleSaveItem}
          type="submit"
          className="max-lg:px-12 flex items-start"
        />
      </form>
    </div>
  );
};

export default PrisEditor;

